<h3>{{ "i18n.base.two-factor-authentication.step-qrcode.header" | translate }}</h3>
<div class="form-group">
  <p>{{ (alternateDescription ?? "i18n.base.two-factor-authentication.step-qrcode.description") | translate }}</p>
</div>
<div class="qr-wrapper">
  <qrcode [qrdata]="qrData.qrCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>
<div class="form-group mt-3">
  <label for="code">{{ "i18n.base.two-factor-authentication.step-qrcode.registration-code" | translate }}</label>
  <app-password-input inputId="code"
                      [placeholder]="'i18n.base.login.password' | translate"
                      [ngModel]="qrData.code"
                      [disabled]="true">
  </app-password-input>
</div>
<button class="btn btn-primary btn-right" (click)="onQrCodeRegistered()">
  {{ "i18n.shared.ok" | translate }}
</button>
